import { MyAxios, handleResponse, priorityHandleError, handleError } from '@services/SettingAxios';
import { TypePromiseBasket, TypePromiseInfo } from './TypePromise';
import { defaultCart } from './defaultDataApi';
import { addV1ApiDto, updateApiDto } from './api.dto';

class ServiceCart {
  async getInfo(regionId: number = 1): Promise<TypePromiseInfo> {
    return MyAxios(`/api/user/info?regionId=${regionId}`)
      .then(handleResponse)
      .catch(error => handleError(error, defaultCart));
  }

  addV1(query: addV1ApiDto): Promise<TypePromiseInfo> {
    return MyAxios.put<any>('/api/cart/add-cart-v1', query).then(handleResponse);
  }

  getCartV1(regionId: number): Promise<TypePromiseBasket> {
    return MyAxios(`/api/cart/get-cart-v1?regionId=${regionId}`).then(handleResponse).catch(priorityHandleError);
  }

  update(query: updateApiDto): Promise<any> {
    return MyAxios.post<any>('/api/cart/update-cart-v1', query).then(handleResponse).catch(priorityHandleError);
  }

  remove(productId: number, regionId: number): Promise<any> {
    return MyAxios.delete<any>(`/api/cart/delete-cart-v1?productId=${productId}&regionId=${regionId}`)
      .then(handleResponse)
      .catch(priorityHandleError);
  }

  delete(productId: number, regionId: number): Promise<TypePromiseInfo> {
    return MyAxios.delete<any>(`/api/cart/delete?productId=${productId}&regionId=${regionId}`).then(handleResponse).catch(priorityHandleError);
  }
}

const serviceCartInstance = new ServiceCart();

export default serviceCartInstance;
